<template>
  <v-container fluid>

    <UsedAlert :usedConfig="usedConfig">
    </UsedAlert>

    <v-row>
      <v-col cols=" 12">
        <QTextField v-model="editItem.Id" :label="$t('servicesystem.common_objects.department.id')"
          :rules="[requiredRule]" :disabled="!isNew" :externaledit="isNew && editMode"
          :errormessages="usedConfig ? [usedConfig.message] : undefined" @DebouncedInput="checkDepartmentId"
          @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.Name" :label="$t('servicesystem.common_objects.department.name')"
          :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.Latitude" :label="$t('servicesystem.common_objects.department.latitude')" clearable
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.Longitude" :label="$t('servicesystem.common_objects.department.longitude')"
          clearable :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import UsedAlert from "@/components/UsedAlert.vue";

export default {
  name: "DepartmentEditContent",
  props: {
    originalItem: Object,
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    UsedAlert,
  },
  mixins: [clientAPI],

  data() {
    return {
      used: null,
    };
  },

  mounted() { },

  methods: {
    async checkDepartmentId(id) {
      if (!id) {
        this.used = null;
      } else {
        await this.getDepartmentById(id)
          .then((response) => {
            //console.log(response);
            this.used = response;
          })
          .catch((e) => {
            if (e.status == 204) {
              this.used = null;
            }
            else {
              console.error(e)
            }
          });
      }
    },
  },

  computed: {
    isNew() {
      return this.originalItem?.Id == null;
    },

    usedConfig() {
      if (this.used) {
        return {
          message: this.$t('servicesystem.common_objects.department.department_id_in_use', { kkey: this.$t('servicesystem.common_objects.department.id'), ckey: this.used.Name }),
          openText: this.$t('servicesystem.common_objects.department.view_department', { ckey: this.used.Name }),
          route: { name: 'ViewDepartment', params: { departmentId: this.used.Id } },
        };
      }
      else {
        return null;
      }
    }
  },

  watch: {},
};
</script>


<style lang='scss'></style>